import type { IconData } from '@stacksjs/iconify-core'

export const pen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M345.994 42.019L179.531 208.481a646.3 646.3 0 0 0-154.206 248.04a24.85 24.85 0 0 0 6 25.708l.087.087a24.84 24.84 0 0 0 17.611 7.342a25.2 25.2 0 0 0 8.1-1.344a646.3 646.3 0 0 0 248.04-154.207L471.62 167.646A88.831 88.831 0 0 0 345.994 42.019M282.531 311.48A614.45 614.45 0 0 1 60.419 453.221a614.4 614.4 0 0 1 141.739-222.113l99.162-99.161l80.372 80.372Zm166.462-166.461l-44.674 44.673l-80.372-80.372l44.674-44.674a56.832 56.832 0 1 1 80.372 80.373\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pen
